/**
 * @file     useReducedMotionPreference.ts
 * @purpose  Returns true when the user prefers reduced motion (prefers-reduced-motion: reduce).
 */
'use client';

import { useEffect, useState } from 'react';

export const useReducedMotionPreference = (): boolean => {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return reducedMotion;
};
